import actions from './constants';

export const fetchRequestQueries = (category, code, cohortCode, names) => ({
  type: actions.FETCH_REQUEST_QUERIES,
  category,
  code,
  cohortCode,
  names,
});

export const cohortToRequest = (category, code, result, names) => ({
  type: actions.COHORT_TO_REQUEST,
  category,
  code,
  result,
  names,
});

export const cohortToRequestError = (category, code, error) => ({
  type: actions.COHORT_TO_REQUEST_ERROR,
  category,
  code,
  error,
});

export const fetchRequestCohorts = (category, code, page, pageSize, append) => ({
  type: actions.FETCH_REQUEST_COHORTS,
  category,
  code,
  page,
  pageSize,
  append,
});

export const updateRequestCohortsFilter = (category, code, value) => ({
  type: actions.UPDATE_REQUEST_COHORTS_FILTER,
  category,
  code,
  value,
});

export const toggleRequestCohortSelected = (category, code, cohortCode) => ({
  type: actions.TOGGLE_REQUEST_COHORT_SELECTED,
  category,
  code,
  cohortCode,
});

export const updateRequestCohortsFlags = (category, code, { privateFlag, internalFlag }) => ({
  type: actions.UPDATE_REQUEST_COHORTS_FLAGS,
  category,
  code,
  privateFlag,
  internalFlag,
});

export const showRequestCohorts = (
  category,
  code,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
) => ({
  type: actions.SHOW_REQUEST_COHORTS,
  category,
  code,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
});

export const updateRequestQueries = (category, code, identifiers) => ({
  type: actions.UPDATE_REQUEST_QUERIES,
  category,
  code,
  identifiers,
});
